import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MaintenanceType } from '../../core/models/maintenance-type.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-maintenance-type-detail',
  templateUrl: './maintenance-type-detail.component.html',
  styleUrls: ['./maintenance-type-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class MaintenanceTypeDetailComponent implements OnInit {
  @Input() maintenanceType: MaintenanceType | null = null; // Recibir el tipo de mantenimiento
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
